{
  "StatusEffect": [
    {
      "item_id": "658B4D83-322B-42FA-82AB-49D3BAD33590",
      "item_name": "Ageless",
      "variable_name": "ageless",
      "status_type": "boon"
    },
    {
      "item_id": "9529EEA7-63A9-C572-ECA9-F523E87C58A8",
      "item_name": "Deafened",
      "variable_name": "deafened",
      "status_type": "bane"
    },
    {
      "item_id": "4638F1B5-48F9-4E81-95B7-E0325F40B5EF",
      "item_name": "Diseased",
      "variable_name": "diseased",
      "status_type": "bane"
    },
    {
      "item_id": "D9043BEC-2EFF-BC30-BE5C-270D7E1A68A8",
      "item_name": "Poisoned",
      "variable_name": "poisoned",
      "status_type": "bane"
    },
    {
      "item_id": "A176161E-3825-86D8-7BE7-C1524A5B19D4",
      "item_name": "Food Poisoning",
      "variable_name": "food_poisoning",
      "status_type": "bane"
    },
    {
      "item_id": "F5ACBDB4-D923-3684-57F6-FBF3F720AEFA",
      "item_name": "Prone",
      "variable_name": "prone",
      "status_type": "bane"
    },
    {
      "item_id": "095BC6BC-06F6-74E0-2B8A-FC1F32AF809B",
      "item_name": "Sleeping",
      "variable_name": "sleeping",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "2A20ACDF-3BC6-B964-8FBD-F8E1AC581AA5",
      "item_name": "Suffocating",
      "variable_name": "suffocating",
      "status_type": "bane"
    },
    {
      "item_id": "1E8008FA-B68A-8DE8-48CE-0EB121008FEB",
      "item_name": "Drowning",
      "variable_name": "drowning",
      "status_type": "bane"
    },
    {
      "item_id": "7B044913-E45E-04C9-F25C-5FB8B8C503F4",
      "item_name": "Surprised",
      "variable_name": "surprised",
      "status_type": "bane"
    },
    {
      "item_id": "F73BA661-ADD2-26E0-E265-FBEB7E5E6AF1",
      "item_name": "Unconscious",
      "variable_name": "unconscious",
      "status_type": "bane"
    },
    {
      "item_id": "799B512F-C685-9655-0AF0-8CFBE0349130",
      "item_name": "Truthsayer",
      "variable_name": "truthsayer",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "DCB240F7-C033-1B9C-0E27-446C5C1F4D0C",
      "item_name": "Repelled",
      "variable_name": "repelled",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "BCC91DAF-AF10-497E-241D-ACD1BEC9E80E",
      "item_name": "Silenced",
      "variable_name": "silenced",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "83EAD975-053D-1DDA-4474-F2128633500E",
      "item_name": "Withering",
      "variable_name": "withering",
      "status_type": "bane",
      "applies_to_compositions": [
        "wood",
        "flesh",
        "living"
      ]
    },
    {
      "item_id": "3E9BD118-C5FB-2C0A-01CF-72DC2C4ED0E8",
      "item_name": "Challenged",
      "variable_name": "challenged",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "D5A31654-692A-B4BE-49DC-2B3360F76D4A",
      "item_name": "Confused",
      "variable_name": "confused",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "B5E6379E-5869-4B82-3EB4-9ACB48D2F82A",
      "item_name": "Feebleminded",
      "variable_name": "feebleminded",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "3188FB3B-C860-43D4-9BA0-40364C460385",
      "item_name": "Resting",
      "variable_name": "resting",
      "status_type": "bane"
    },
    {
      "item_id": "8A6575CF-BCA9-2E70-5ECB-21FE529FCAB6",
      "item_name": "Soul Breaker",
      "variable_name": "soul_breaker",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "39F1A03D-A7C7-4E90-98FD-14F508074BC5",
      "item_name": "Unimpeded",
      "variable_name": "unimpeded",
      "status_type": "boon",
      "ends_on_caster_death": true
    },
    {
      "item_id": "EC8F4821-26B6-4874-86E0-2B344CDC8B4F",
      "item_name": "Reckless",
      "variable_name": "reckless",
      "status_type": "boon"
    },
    {
      "item_id": "E7FDB796-26DA-E0F5-8F88-C21FE01D923B",
      "item_name": "Concentrating",
      "variable_name": "concentrating",
      "status_type": "bane"
    },
    {
      "item_id": "AE967694-B94B-F0FF-B680-829FDE6E8D58",
      "item_name": "Searching",
      "variable_name": "searching",
      "status_type": "bane"
    },
    {
      "item_id": "A311574A-3513-44AB-8C70-3C3006F6CC40",
      "item_name": "Consecrated",
      "variable_name": "consecrated",
      "status_type": "none"
    },
    {
      "item_id": "321DA526-E48E-F202-10FC-D3A2B03485F2",
      "item_name": "Frightened",
      "variable_name": "frightened",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "057BA9B2-177C-40A6-8815-8063DDDC0D9B",
      "item_name": "AOE Redirection",
      "variable_name": "aoe_redirection",
      "status_type": "none",
      "ends_on_caster_death": true
    },
    {
      "item_id": "83234E69-6C06-3392-256B-CB3796C180A7",
      "item_name": "Incorporeal",
      "variable_name": "incorporeal",
      "status_type": "boon"
    },
    {
      "item_id": "9DF8FF4C-33E8-8095-4876-ED3DBCD50B79",
      "item_name": "Spell Locked",
      "variable_name": "spell_locked",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "2A64D1E8-7C3B-4F92-B5A8-E19D64C72F35",
      "item_name": "Abjuration Locked",
      "variable_name": "circle_locked_abjuration",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "9E15B7A2-3D48-4C61-A927-F84B21D6E593",
      "item_name": "Charm Locked",
      "variable_name": "circle_locked_charm",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "6C82F394-1A5D-4E76-8B34-D29E75A1C648",
      "item_name": "Conjuration Locked",
      "variable_name": "circle_locked_conjuration",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "4F37A8D1-9B62-4A15-C783-28E91B5F4D76",
      "item_name": "Divination Locked",
      "variable_name": "circle_locked_divination",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "8D21C6F5-4E93-4B27-A164-73F8D2E9B5A4",
      "item_name": "Evocation Locked",
      "variable_name": "circle_locked_evocation",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "3B96E4A7-2F51-4D38-9C82-46A1E7D3F925",
      "item_name": "Illusion Locked",
      "variable_name": "circle_locked_illusion",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "7A45D2B9-6C18-4F63-B591-82D4F6A3E1C7",
      "item_name": "Necromancy Locked",
      "variable_name": "circle_locked_necromancy",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "5E63B1C4-8A27-4D95-A348-91C6E2F7D8B3",
      "item_name": "Transmutation Locked",
      "variable_name": "circle_locked_transmutation",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "1D87F5A3-6B42-4C19-8E75-34A9D1B6C2F8",
      "item_name": "Arcane Sphere Locked",
      "variable_name": "sphere_locked_arcane",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "9C34A6E1-5D78-4B26-A493-67F2E8D5B1A9",
      "item_name": "Divine Sphere Locked",
      "variable_name": "sphere_locked_divine",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "6F92C3D7-1E85-4A64-B237-58D1A9F4E6C3",
      "item_name": "Primal Sphere Locked",
      "variable_name": "sphere_locked_primal",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "1710A01B-FAF1-4684-5050-A10386685D35",
      "item_name": "Inverted",
      "variable_name": "inverted",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "DB1C8E56-CBD7-09E4-0FBF-148F28A93D67",
      "item_name": "Fleeing",
      "variable_name": "fleeing",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "DA2F74EB-CF67-AEEB-0DE1-376C6BB7CABA",
      "item_name": "Holy Turned",
      "variable_name": "holy_turned",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "D31E3DD8-FFA1-67EC-D3F4-FCD323059091",
      "item_name": "Disguised",
      "variable_name": "disguised",
      "status_type": "boon"
    },
    {
      "item_id": "EEDD357F-C1CA-44C1-A53F-DD06EEFBA597",
      "item_name": "Holding Mastery",
      "variable_name": "holding_mastery",
      "status_type": "boon"
    },
    {
      "item_id": "D09D563D-0689-4B56-AEAA-5A254DC408A4",
      "item_name": "Performing a Melody",
      "variable_name": "performing_a_melody",
      "status_type": "boon"
    },
    {
      "item_id": "2858158E-5E6A-491B-9824-290DE8D692D8",
      "item_name": "Shadowform",
      "variable_name": "shadowform",
      "status_type": "boon"
    },
    {
      "item_id": "331C8511-F8A7-4626-AF17-48FAF062FE50",
      "item_name": "Fate Card Suit Love",
      "variable_name": "fate_card_suit_love",
      "status_type": "boon"
    },
    {
      "item_id": "D9394C92-068A-FAFA-231D-289157FD2980",
      "item_name": "Fate Card Suit War",
      "variable_name": "fate_card_suit_war",
      "status_type": "boon"
    },
    {
      "item_id": "34987D5C-BB13-7633-E28A-C3DA4BD458A7",
      "item_name": "Fate Card Suit Prosperity",
      "variable_name": "fate_card_suit_prosperity",
      "status_type": "boon"
    },
    {
      "item_id": "6A31B8DA-8AD6-ACC1-9E3A-3A8DD77FD43D",
      "item_name": "Fate Card Suit Change",
      "variable_name": "fate_card_suit_change",
      "status_type": "boon"
    },
    {
      "item_id": "C8163F62-7B18-8221-A60D-C9DD775682E3",
      "item_name": "Trackers Brand",
      "variable_name": "trackers_brand",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "D343892B-338C-4FBE-BEA0-2015FE503F43",
      "item_name": "Donning",
      "variable_name": "donning",
      "status_type": "bane"
    },
    {
      "item_id": "398DD6E8-AFAE-EA0D-6FE9-C22842D53775",
      "item_name": "Doffing",
      "variable_name": "doffing",
      "status_type": "bane"
    },
    {
      "item_id": "ED30CCB0-1645-B97E-B9A6-867D8D0094BD",
      "item_name": "Reading",
      "variable_name": "reading",
      "status_type": "bane"
    },
    {
      "item_id": "426C7E0B-EF44-498C-10B2-B50A9E28E45C",
      "item_name": "Training",
      "variable_name": "training",
      "status_type": "bane"
    },
    {
      "item_id": "78C51D2D-5178-551C-1249-B5DDA4083098",
      "item_name": "Trapped",
      "variable_name": "trapped",
      "status_type": "boon"
    },
    {
      "item_id": "477A7977-60D2-4B9C-96B0-6ED4BFD6437E",
      "item_name": "Locked",
      "variable_name": "locked",
      "status_type": "boon"
    },
    {
      "item_id": "36C061BF-E480-4334-961C-26500150E3C4",
      "item_name": "Integrated Object",
      "variable_name": "integrated_object",
      "status_type": "none"
    },
    {
      "item_id": "B84EBE3F-B385-4CEF-9C69-648086C4CB7D",
      "item_name": "Summon Tag",
      "variable_name": "summon_tag",
      "status_type": "none"
    },
    {
      "item_id": "5AA76DEE-CE52-E021-67CD-8C701DA0E56F",
      "item_name": "Awake",
      "variable_name": "awake",
      "status_type": "none"
    },
    {
      "item_id": "FD5CB2E3-B247-274A-5B42-25F538F72661",
      "item_name": "Weary",
      "variable_name": "weary",
      "status_type": "bane"
    },
    {
      "item_id": "A707303F-CE4F-26D8-8846-B5178D3F1DB2",
      "item_name": "Nondetection Effect",
      "variable_name": "nondetection_effect",
      "status_type": "boon"
    },
    {
      "item_id": "B9DC5478-8F86-29F7-15D8-1C8CE8171F12",
      "item_name": "Spider Climb Effect",
      "variable_name": "spider_climb_effect",
      "status_type": "boon"
    },
    {
      "item_id": "A13061B6-2390-14E8-34E0-366C0E0CDE34",
      "item_name": "Water Walk Effect",
      "variable_name": "water_walk_effect",
      "status_type": "boon"
    },
    {
      "item_id": "5D939B6E-B9BC-7AC5-5143-4F00F4189EA3",
      "item_name": "Casting",
      "variable_name": "casting",
      "status_type": "bane"
    },
    {
      "item_id": "5833A733-D277-0A60-3A94-A0F355A79A80",
      "item_name": "Casting Ritual Spell",
      "variable_name": "casting_ritual_spell",
      "status_type": "bane"
    },
    {
      "item_id": "62ED7394-9C33-D41A-C426-1BC6723C999A",
      "item_name": "Crafting",
      "variable_name": "crafting",
      "status_type": "bane"
    },
    {
      "item_id": "E49AA8BA-1F60-4FD8-B3C0-852BBA3978C3",
      "item_name": "Crafting Progress",
      "variable_name": "crafting_progress",
      "status_type": "none"
    },
    {
      "item_id": "1C4D81BB-FB79-68AD-E881-28D874927FD2",
      "item_name": "Disenchanting",
      "variable_name": "disenchanting",
      "status_type": "bane"
    },
    {
      "item_id": "FF9A38A3-5F35-F083-E153-7DF41B0C0826",
      "item_name": "Lockpicking",
      "variable_name": "lockpicking",
      "status_type": "bane"
    },
    {
      "item_id": "3F171782-CC56-32DF-81B4-8C0ED89F47F4",
      "item_name": "Gathering",
      "variable_name": "gathering",
      "status_type": "bane"
    },
    {
      "item_id": "7B3E9C4A-1D62-4F08-A5D7-3E90C1B84F26",
      "item_name": "Excavation Found",
      "variable_name": "excavation_found",
      "status_type": "none"
    },
    {
      "item_id": "A64E346E-F58C-5FB7-BE30-71232C06897C",
      "item_name": "Slightly Drunk",
      "variable_name": "slightly_drunk",
      "status_type": "bane"
    },
    {
      "item_id": "67B9CAB7-1C48-41E0-AEAF-2F4A352075C1",
      "item_name": "Drunk",
      "variable_name": "drunk",
      "status_type": "bane"
    },
    {
      "item_id": "09FC38BC-6060-4B67-A33F-EF7D448F71F1",
      "item_name": "Burning",
      "variable_name": "burning",
      "status_type": "bane"
    },
    {
      "item_id": "996886D6-67F7-2A7D-0336-9324C877CAA6",
      "item_name": "Melting",
      "variable_name": "melting",
      "status_type": "bane"
    },
    {
      "item_id": "F632281D-2F16-FFDA-FB95-2E958988F01F",
      "item_name": "Corroding",
      "variable_name": "corroding",
      "status_type": "bane"
    },
    {
      "item_id": "F90FB02F-2549-6FE0-A162-CC3FA7C90C67",
      "item_name": "Dissolving",
      "variable_name": "dissolving",
      "status_type": "bane"
    },
    {
      "item_id": "E3169368-A4EF-476F-B699-5EFE62C7CE2A",
      "item_name": "Wet",
      "variable_name": "wet",
      "status_type": "bane"
    },
    {
      "item_id": "99951E6E-9801-4E3E-A684-4D111F2D6624",
      "item_name": "Chilled",
      "variable_name": "chilled",
      "status_type": "bane"
    },
    {
      "item_id": "84CD1B4A-0D7C-9385-8128-D91339F269BF",
      "item_name": "Freezing",
      "variable_name": "freezing",
      "status_type": "bane"
    },
    {
      "item_id": "6EFBE105-7632-4C64-BC04-206CEAF663E6",
      "item_name": "Frozen",
      "variable_name": "frozen",
      "status_type": "bane"
    },
    {
      "item_id": "E5452E0D-251E-4BDD-AC25-DADD00A7BEC7",
      "item_name": "Electrocuted",
      "variable_name": "electrocuted",
      "status_type": "bane"
    },
    {
      "item_id": "F711788C-2BB4-4114-8339-B3C85BE0D52A",
      "item_name": "Shocked",
      "variable_name": "shocked",
      "status_type": "bane"
    },
    {
      "item_id": "CEFF8A40-503C-FDA3-41B3-43DC06BF762D",
      "item_name": "Blinded",
      "variable_name": "blinded",
      "status_type": "bane"
    },
    {
      "item_id": "0313A4D7-C1C2-4D1B-8DD7-CC6EDBC42065",
      "item_name": "Dimmed",
      "variable_name": "dimmed",
      "status_type": "bane"
    },
    {
      "item_id": "4B74DA87-EABF-7EBA-D283-C5A1FEF483C9",
      "item_name": "Sightless",
      "variable_name": "sightless",
      "status_type": "bane"
    },
    {
      "item_id": "3E053858-D7C1-4E36-91A7-AF05EF5D0C62",
      "item_name": "Photosensitive Eye Strain",
      "variable_name": "photosensitive_eye_strain",
      "status_type": "bane"
    },
    {
      "item_id": "3C038AB7-2684-A787-1809-6C8224DBB285",
      "item_name": "Extreme Photosensitive Eye Strain",
      "variable_name": "extreme_photosensitive_eye_strain",
      "status_type": "bane"
    },
    {
      "item_id": "A1F1FAF2-DA1E-D537-36C2-2B74DC82CB12",
      "item_name": "Piloting",
      "variable_name": "piloting",
      "status_type": "boon"
    },
    {
      "item_id": "DDC66C31-4093-84AF-18BB-093D924B8738",
      "item_name": "Piloted",
      "variable_name": "piloted",
      "status_type": "bane"
    },
    {
      "item_id": "FF8D219A-2A83-0EE5-A222-E748753E8D0B",
      "item_name": "Riding",
      "variable_name": "riding",
      "status_type": "boon"
    },
    {
      "item_id": "680EFB9E-3CFB-491F-A620-5BABF800131C",
      "item_name": "Mounted",
      "variable_name": "mounted",
      "status_type": "bane"
    },
    {
      "item_id": "F13F6A58-FE91-F24D-12BE-BE7CCAD81A40",
      "item_name": "Ridden",
      "variable_name": "ridden",
      "status_type": "bane"
    },
    {
      "item_id": "E2054884-038E-3D6E-56C5-19ABBFED8379",
      "item_name": "Obscured",
      "variable_name": "obscured",
      "status_type": "boon"
    },
    {
      "item_id": "1BA5473E-6218-6688-1C68-DCA4FEF00A97",
      "item_name": "Sneaking",
      "variable_name": "sneaking",
      "status_type": "bane"
    },
    {
      "item_id": "47667406-1B72-9D60-310B-D8CF6BFE397D",
      "item_name": "Hidden",
      "variable_name": "hidden",
      "status_type": "boon"
    },
    {
      "item_id": "84B91EEB-2FA6-D1CB-1347-75BFBDA2A6DD",
      "item_name": "Invisible",
      "variable_name": "invisible",
      "status_type": "boon"
    },
    {
      "item_id": "B6232175-C357-9A97-0ACA-7ECC67563635",
      "item_name": "Greater Invisible",
      "variable_name": "greater_invisible",
      "status_type": "boon"
    },
    {
      "item_id": "2A2845CD-949F-06E2-E6B2-98CFD5603241",
      "item_name": "Ethereal",
      "variable_name": "ethereal",
      "status_type": "boon"
    },
    {
      "item_id": "B9693027-E65E-DAFF-B2C5-7CF31927184D",
      "item_name": "Flanked",
      "variable_name": "flanked",
      "status_type": "bane"
    },
    {
      "item_id": "3A2FD2B0-28A9-62D3-CB13-A22974618CDB",
      "item_name": "Partial Cover",
      "variable_name": "partial_cover",
      "status_type": "boon"
    },
    {
      "item_id": "A126C1D6-FE3E-5578-DCC6-CBBF8742E9C1",
      "item_name": "Full Cover",
      "variable_name": "full_cover",
      "status_type": "boon"
    },
    {
      "item_id": "BE6DC590-4EB7-B297-5AC6-8E47AA4E00EF",
      "item_name": "Hunkered Down",
      "variable_name": "hunkered_down",
      "status_type": "boon"
    },
    {
      "item_id": "306CD53D-AD03-DD13-FDDF-34D9120613CD",
      "item_name": "Encumbered",
      "variable_name": "encumbered",
      "status_type": "bane"
    },
    {
      "item_id": "49F87D1B-3878-789E-D52E-65BA7F2F4218",
      "item_name": "Heavily Encumbered",
      "variable_name": "heavily_encumbered",
      "status_type": "bane"
    },
    {
      "item_id": "1AEA950E-A57E-6059-448A-E4A6FCED97A3",
      "item_name": "Shield Encumbered",
      "variable_name": "shield_encumbered",
      "status_type": "bane"
    },
    {
      "item_id": "466374FE-D89C-DB77-1809-7249A831015D",
      "item_name": "Armor Encumbered",
      "variable_name": "armor_encumbered",
      "status_type": "bane"
    },
    {
      "item_id": "10278E95-5320-A57E-471F-C3E7AEFA70BA",
      "item_name": "Bolstered",
      "variable_name": "bolstered",
      "status_type": "boon",
      "ends_on_caster_death": true
    },
    {
      "item_id": "EB6FB558-7427-A647-8F46-D2E8C25F1F60",
      "item_name": "Exhausted",
      "variable_name": "exhausted",
      "status_type": "bane"
    },
    {
      "item_id": "BF31EE0A-5B3C-370B-0118-96B067CFD929",
      "item_name": "Paralyzed",
      "variable_name": "paralyzed",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "F2CD1603-38A4-85E9-D148-CE3D429310A2",
      "item_name": "Banished",
      "variable_name": "banished",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "D218F4FB-5693-87B9-93C1-776FC1F7ED90",
      "item_name": "Stunned",
      "variable_name": "stunned",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "B404E7CA-C073-473E-A799-A71601A22DE5",
      "item_name": "Dazed",
      "variable_name": "dazed",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "6CCB9287-4420-962A-2952-7469394A5C7A",
      "item_name": "Backlash",
      "variable_name": "backlash",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "DD4C0995-C3D2-43A3-CFC7-226C3005274C",
      "item_name": "Charmed",
      "variable_name": "charmed",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "D2E7BA2C-562D-D4AC-7F71-13E4AC540484",
      "item_name": "Dominated",
      "variable_name": "dominated",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "185D46F5-09E2-1921-F721-FDD0A2AB3EFC",
      "item_name": "Possessed",
      "variable_name": "possessed",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "E4A34093-AAAB-6453-BCE0-FBA65EE263AD",
      "item_name": "Grappling",
      "variable_name": "grappling",
      "status_type": "boon"
    },
    {
      "item_id": "0C2A8037-B0BC-8300-C818-198881B00E7D",
      "item_name": "Grappled",
      "variable_name": "grappled",
      "status_type": "bane"
    },
    {
      "item_id": "E34AF232-5438-88FC-9A9F-73850CCCFD51",
      "item_name": "Restrained",
      "variable_name": "restrained",
      "status_type": "bane"
    },
    {
      "item_id": "F40E19A3-FC86-187F-050E-8C8B69761353",
      "item_name": "Immobile",
      "variable_name": "immobile",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "BC6671F6-DEDF-9C1B-C459-226E7388A00C",
      "item_name": "Slowed",
      "variable_name": "slowed",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "90D15611-2833-46D6-A72E-04C16C87972F",
      "item_name": "Hindered",
      "variable_name": "hindered",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "9FD8A4D0-B09B-C068-D475-7EAB358D1A1E",
      "item_name": "Hamstrung",
      "variable_name": "hamstrung",
      "status_type": "bane"
    },
    {
      "item_id": "64318AE9-0187-4C71-9163-084694BCE180",
      "item_name": "Sluggish",
      "variable_name": "sluggish",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "75B1C2F6-8E21-0ED0-32AD-C49B68804CCC",
      "item_name": "Rushed",
      "variable_name": "rushed",
      "status_type": "boon",
      "ends_on_caster_death": true
    },
    {
      "item_id": "091B2BEE-7F61-D7DB-0CF1-6D255F4B7663",
      "item_name": "Hasted",
      "variable_name": "hasted",
      "status_type": "boon",
      "ends_on_caster_death": true
    },
    {
      "item_id": "EAA88590-DB1D-7C46-F523-E87A31912777",
      "item_name": "Dizzy",
      "variable_name": "dizzy",
      "status_type": "bane"
    },
    {
      "item_id": "9853CC89-CE34-4077-5453-59605542265C",
      "item_name": "Staggered",
      "variable_name": "staggered",
      "status_type": "bane"
    },
    {
      "item_id": "BE55F5A2-74F7-63D0-D169-900934E2E26E",
      "item_name": "Impaired",
      "variable_name": "impaired",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "3AD27E05-55EB-4B79-83F6-FC88ADEBD342",
      "item_name": "Exposed",
      "variable_name": "exposed",
      "status_type": "bane"
    },
    {
      "item_id": "75682F12-AB67-401B-97D7-F1B7354333CA",
      "item_name": "Squeezed",
      "variable_name": "squeezed",
      "status_type": "bane"
    },
    {
      "item_id": "B45813FE-321A-EC7F-F008-12B8FD33B524",
      "item_name": "Very Squeezed",
      "variable_name": "very_squeezed",
      "status_type": "bane"
    },
    {
      "item_id": "98FEA101-0910-41AE-9E20-E126C8B73AFC",
      "item_name": "Protected",
      "variable_name": "protected",
      "status_type": "boon",
      "ends_on_caster_death": true
    },
    {
      "item_id": "256BCFFB-B0BF-7C7A-B238-3126CA2AC20C",
      "item_name": "Powerful",
      "variable_name": "powerful",
      "status_type": "boon",
      "ends_on_caster_death": true
    },
    {
      "item_id": "091CBC18-FF1D-6072-3190-90EFAEDDE6F5",
      "item_name": "Greater Powerful",
      "variable_name": "greater_powerful",
      "status_type": "boon",
      "ends_on_caster_death": true
    },
    {
      "item_id": "C518B122-A108-4EA3-B140-E6211C1071BB",
      "item_name": "Empowered",
      "variable_name": "empowered",
      "status_type": "boon",
      "ends_on_caster_death": true
    },
    {
      "item_id": "B49068EF-8A0A-0002-3476-E214504C3570",
      "item_name": "Weakened",
      "variable_name": "weakened",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "CAD2A16E-0DB5-91C5-F7F4-24F46B28011C",
      "item_name": "Greater Weakened",
      "variable_name": "greater_weakened",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "F450C824-98D3-D0B1-D6B1-C326F15F1578",
      "item_name": "Enfeebled",
      "variable_name": "enfeebled",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "DD53CA8E-DF3D-9AF4-49CB-9C61926BBB93",
      "item_name": "Defenseless",
      "variable_name": "defenseless",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "F55C0D31-091D-0F3F-74F0-AEE4C20BE1ED",
      "item_name": "Vulnerable",
      "variable_name": "vulnerable",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "60912827-B1B3-E9D7-6FBF-1FE976DDD04E",
      "item_name": "Shelled",
      "variable_name": "shelled",
      "status_type": "boon",
      "ends_on_caster_death": true
    },
    {
      "item_id": "8912E655-C826-4CF6-8F3C-B036AC710CE3",
      "item_name": "Resistant",
      "variable_name": "resistant",
      "status_type": "boon",
      "ends_on_caster_death": true
    },
    {
      "item_id": "1194F357-C419-2931-27B4-3B56F26BFBA7",
      "item_name": "Invulnerable",
      "variable_name": "invulnerable",
      "status_type": "boon",
      "ends_on_caster_death": true
    },
    {
      "item_id": "88F8F0BA-3E96-4D9C-AFCE-008D849B0BFC",
      "item_name": "Hunger and Thirst Tick",
      "variable_name": "hunger_and_thirst_tick",
      "status_type": "none"
    },
    {
      "item_id": "6FAF0CD0-26E2-60A3-0608-A3C8E1828027",
      "item_name": "Thirsty",
      "variable_name": "thirsty",
      "status_type": "bane"
    },
    {
      "item_id": "C1F4E2B6-DA45-8CAC-322D-C5DF54FFC418",
      "item_name": "Parched",
      "variable_name": "parched",
      "status_type": "bane"
    },
    {
      "item_id": "2611657A-9C0A-4680-AB51-62235A6D8D79",
      "item_name": "Desiccating",
      "variable_name": "desiccating",
      "status_type": "bane"
    },
    {
      "item_id": "5672B433-B59D-561E-B4C6-79565C46B3CA",
      "item_name": "Hungry",
      "variable_name": "hungry",
      "status_type": "bane"
    },
    {
      "item_id": "7780B669-28AA-680E-D28D-397B05A15FC6",
      "item_name": "Starving",
      "variable_name": "starving",
      "status_type": "bane"
    },
    {
      "item_id": "457ADEAA-1D5D-9AB4-EFC9-2B7120C78BAA",
      "item_name": "Petrified",
      "variable_name": "petrified",
      "status_type": "bane"
    },
    {
      "item_id": "DFCF49C0-D5BC-C56F-A7C5-DC8D134ED7D7",
      "item_name": "Petrifying",
      "variable_name": "petrifying",
      "status_type": "bane",
      "transitional": {
        "progresses_to": "petrified",
        "retry_skill": "fortitude",
        "retry_dc": 10
      }
    },
    {
      "item_id": "3BE713AB-37D7-630B-C1F8-9470784BA33E",
      "item_name": "Bleeding",
      "variable_name": "bleeding",
      "status_type": "bane"
    },
    {
      "item_id": "22E33A8E-DF5D-2596-8E2D-0E8A8528E47C",
      "item_name": "Moderate Bleeding",
      "variable_name": "moderate_bleeding",
      "status_type": "bane"
    },
    {
      "item_id": "BAAA237B-1AA7-0409-5BC7-1A6720573069",
      "item_name": "Severe Bleeding",
      "variable_name": "severe_bleeding",
      "status_type": "bane"
    },
    {
      "item_id": "A5CDC77C-D224-DD5F-291B-EF8DF2EA443D",
      "item_name": "Maimed",
      "variable_name": "maimed",
      "status_type": "bane"
    },
    {
      "item_id": "9437F344-1461-B4C0-E196-6BA1A34ADC94",
      "item_name": "Maimed 1",
      "variable_name": "maimed_1",
      "status_type": "bane"
    },
    {
      "item_id": "9154FF1F-721A-2BCA-1AEF-24AC7B32FE4B",
      "item_name": "Maimed 2",
      "variable_name": "maimed_2",
      "status_type": "bane"
    },
    {
      "item_id": "46F27428-2B73-50F7-6F0C-D4FAFDB753ED",
      "item_name": "Maimed 3",
      "variable_name": "maimed_3",
      "status_type": "bane"
    },
    {
      "item_id": "4D27433B-6F72-47BB-9A60-B80493F22D65",
      "item_name": "Maimed 4",
      "variable_name": "maimed_4",
      "status_type": "bane"
    },
    {
      "item_id": "E4994653-49B3-D768-35C1-36C8DE40CC1A",
      "item_name": "Maimed 5",
      "variable_name": "maimed_5",
      "status_type": "bane"
    },
    {
      "item_id": "5C557D5A-B85F-DF45-3CF6-6739D2BD70EC",
      "item_name": "Maimed 6",
      "variable_name": "maimed_6",
      "status_type": "bane"
    },
    {
      "item_id": "44D4504C-9BD5-0B65-F8E2-6DC4A0F820B4",
      "item_name": "Maimed 7",
      "variable_name": "maimed_7",
      "status_type": "bane"
    },
    {
      "item_id": "1DEE12B6-D23A-7470-812E-CE4C77AAD395",
      "item_name": "Maimed 8",
      "variable_name": "maimed_8",
      "status_type": "bane"
    },
    {
      "item_id": "4AEF8F40-B779-C0AD-4455-2DABE7B1D14B",
      "item_name": "Maimed 9",
      "variable_name": "maimed_9",
      "status_type": "bane"
    },
    {
      "item_id": "A230F5E6-B6AD-8091-4F59-5E454776B4FA",
      "item_name": "Maimed 10",
      "variable_name": "maimed_10",
      "status_type": "bane"
    },
    {
      "item_id": "CEF623E6-6A71-37FD-29C7-12988B43151A",
      "item_name": "Arcane Fatigue",
      "variable_name": "arcane_fatigue",
      "status_type": "bane"
    },
    {
      "item_id": "F8E5F274-2F31-1340-6167-ED9131E81A88",
      "item_name": "Arcane Fatigue 1",
      "variable_name": "arcane_fatigue_1",
      "status_type": "bane"
    },
    {
      "item_id": "E18A79D1-AA69-7F80-2579-78B583E0771B",
      "item_name": "Arcane Fatigue 2",
      "variable_name": "arcane_fatigue_2",
      "status_type": "bane"
    },
    {
      "item_id": "20F461C2-67CC-BEF6-E02A-4E9A464EC397",
      "item_name": "Arcane Fatigue 3",
      "variable_name": "arcane_fatigue_3",
      "status_type": "bane"
    },
    {
      "item_id": "EF165E68-DD93-90C8-A848-01D93B041CBD",
      "item_name": "Arcane Fatigue 4",
      "variable_name": "arcane_fatigue_4",
      "status_type": "bane"
    },
    {
      "item_id": "DA5A18C5-FDE5-D20B-0E3B-07B68E6C7C1C",
      "item_name": "Arcane Fatigue 5",
      "variable_name": "arcane_fatigue_5",
      "status_type": "bane"
    },
    {
      "item_id": "683632D7-756C-0165-9E94-27EA95A53A53",
      "item_name": "Arcane Fatigue 6",
      "variable_name": "arcane_fatigue_6",
      "status_type": "bane"
    },
    {
      "item_id": "E19F0AB8-E760-D84A-85C3-1A14E7DFE399",
      "item_name": "Arcane Fatigue 7",
      "variable_name": "arcane_fatigue_7",
      "status_type": "bane"
    },
    {
      "item_id": "5F87B80F-A8E4-A3BE-6FC6-3B5BC0A669E9",
      "item_name": "Arcane Fatigue 8",
      "variable_name": "arcane_fatigue_8",
      "status_type": "bane"
    },
    {
      "item_id": "E29189CC-A2FA-B06A-5DBD-8551A3259829",
      "item_name": "Arcane Fatigue 9",
      "variable_name": "arcane_fatigue_9",
      "status_type": "bane"
    },
    {
      "item_id": "BDAF9378-AA7A-445F-D24F-8E6A0EE84456",
      "item_name": "Arcane Fatigue 10",
      "variable_name": "arcane_fatigue_10",
      "status_type": "bane"
    },
    {
      "item_id": "4744C91C-51DC-4C36-8C6E-DB801410FF61",
      "item_name": "Blighted",
      "variable_name": "blighted",
      "status_type": "bane"
    },
    {
      "item_id": "5CB84B6E-E636-B4A3-3864-910DBD3B63B4",
      "item_name": "Blighted 1",
      "variable_name": "blighted_1",
      "status_type": "bane"
    },
    {
      "item_id": "1B912A78-2334-D265-2674-7AD764534D56",
      "item_name": "Blighted 2",
      "variable_name": "blighted_2",
      "status_type": "bane"
    },
    {
      "item_id": "7F938839-F44A-FA43-05FA-BAAF79B7A05B",
      "item_name": "Blighted 3",
      "variable_name": "blighted_3",
      "status_type": "bane"
    },
    {
      "item_id": "FCC88F77-777D-56B1-913E-E676C90E39E3",
      "item_name": "Blighted 4",
      "variable_name": "blighted_4",
      "status_type": "bane"
    },
    {
      "item_id": "655383C0-8B0C-3B33-694D-26404400626D",
      "item_name": "Blighted 5",
      "variable_name": "blighted_5",
      "status_type": "bane"
    },
    {
      "item_id": "36B68995-C875-199D-20E8-1A1098F846B0",
      "item_name": "Blighted 6",
      "variable_name": "blighted_6",
      "status_type": "bane"
    },
    {
      "item_id": "D9668790-E866-861A-FDE0-D23D2903B0FA",
      "item_name": "Blighted 7",
      "variable_name": "blighted_7",
      "status_type": "bane"
    },
    {
      "item_id": "90D143BD-9CC9-06F7-F339-03F50C27D958",
      "item_name": "Blighted 8",
      "variable_name": "blighted_8",
      "status_type": "bane"
    },
    {
      "item_id": "8A3B8D76-ED7A-560A-166D-73093DE6F4E9",
      "item_name": "Blighted 9",
      "variable_name": "blighted_9",
      "status_type": "bane"
    },
    {
      "item_id": "E64821CE-A9A5-D2C3-4116-8A8D5DCA4D30",
      "item_name": "Blighted 10",
      "variable_name": "blighted_10",
      "status_type": "bane"
    },
    {
      "item_id": "EB6632D3-5EC0-4E4D-5C6C-1BCB7EF57022",
      "item_name": "Shielded",
      "variable_name": "shielded",
      "status_type": "boon",
      "ends_on_caster_death": true
    },
    {
      "item_id": "BF823982-6FC8-51F0-F452-5BE1C949FBA6",
      "item_name": "Shielded 1",
      "variable_name": "shielded_1",
      "status_type": "boon",
      "ends_on_caster_death": true
    },
    {
      "item_id": "36DA5B89-CA08-3940-E798-FCAE6BE775D5",
      "item_name": "Shielded 2",
      "variable_name": "shielded_2",
      "status_type": "boon",
      "ends_on_caster_death": true
    },
    {
      "item_id": "8346CCFF-3A5B-F0E4-CFDE-6CF1D1ED3368",
      "item_name": "Shielded 3",
      "variable_name": "shielded_3",
      "status_type": "boon",
      "ends_on_caster_death": true
    },
    {
      "item_id": "E5314BED-1269-3A65-8C15-01E80A3A8E23",
      "item_name": "Shielded 4",
      "variable_name": "shielded_4",
      "status_type": "boon",
      "ends_on_caster_death": true
    },
    {
      "item_id": "E614D75F-CF27-D169-3D91-0D33D9CE354B",
      "item_name": "Shielded 5",
      "variable_name": "shielded_5",
      "status_type": "boon",
      "ends_on_caster_death": true
    },
    {
      "item_id": "A831D8E0-4DC5-4FBF-4A4C-2C9955AE230A",
      "item_name": "Shielded 6",
      "variable_name": "shielded_6",
      "status_type": "boon",
      "ends_on_caster_death": true
    },
    {
      "item_id": "631AAD91-F6A5-879D-5BD6-B7F885AA7FC9",
      "item_name": "Shielded 7",
      "variable_name": "shielded_7",
      "status_type": "boon",
      "ends_on_caster_death": true
    },
    {
      "item_id": "BF1C1C48-8171-90B8-CD83-F2768348629F",
      "item_name": "Shielded 8",
      "variable_name": "shielded_8",
      "status_type": "boon",
      "ends_on_caster_death": true
    },
    {
      "item_id": "2A63EC91-E5B1-17B4-DFB0-199F9E2084A5",
      "item_name": "Shielded 9",
      "variable_name": "shielded_9",
      "status_type": "boon",
      "ends_on_caster_death": true
    },
    {
      "item_id": "01B0F693-7D8A-C588-9B34-CD1F323D8433",
      "item_name": "Shielded 10",
      "variable_name": "shielded_10",
      "status_type": "boon",
      "ends_on_caster_death": true
    },
    {
      "item_id": "D98B076A-3A38-E225-B8E3-A646C69AA29D",
      "item_name": "Judgement",
      "variable_name": "judgement",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "430F1BE4-6522-4468-8E27-426B23D003BF",
      "item_name": "Judgement 1",
      "variable_name": "judgement_1",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "9EFD0898-7C92-6DE4-DD2F-D6F75ECF3B58",
      "item_name": "Judgement 2",
      "variable_name": "judgement_2",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "90FB0BFB-6186-5E01-FD8B-0315D6DFB809",
      "item_name": "Judgement 3",
      "variable_name": "judgement_3",
      "status_type": "bane",
      "ends_on_caster_death": true
    },
    {
      "item_id": "CDC5CFDA-B09C-4A68-820D-6C74D90BD595",
      "item_name": "Mirror Images",
      "variable_name": "mirror_image_effect",
      "status_type": "boon"
    },
    {
      "item_id": "D9B64F38-A817-47B8-AB07-60D59F3D893C",
      "item_name": "Mirror Image 1",
      "variable_name": "mirror_image_1",
      "status_type": "boon"
    },
    {
      "item_id": "AE20C09B-76BE-5BC4-4E33-6E8CFE1F0139",
      "item_name": "Mirror Image 2",
      "variable_name": "mirror_image_2",
      "status_type": "boon"
    },
    {
      "item_id": "479A4B5C-43F3-3559-979B-5BDA8A379F07",
      "item_name": "Mirror Image 3",
      "variable_name": "mirror_image_3",
      "status_type": "boon"
    },
    {
      "item_id": "80585488-CC4B-4A80-8ECE-CB1CE83F2407",
      "item_name": "Fully Rested",
      "variable_name": "fully_rested",
      "status_type": "none"
    },
    {
      "item_id": "82788F70-EBEF-44C4-80E7-6622AD20DD60",
      "item_name": "Invigorated",
      "variable_name": "invigorated",
      "status_type": "none"
    },
    {
      "item_id": "FF30B76E-785D-2CAF-FC66-C131D0548808",
      "item_name": "Fresh",
      "variable_name": "fresh",
      "status_type": "none"
    },
    {
      "item_id": "658483AA-34DE-74E5-C974-E3E202C31CC7",
      "item_name": "Barely Wounded",
      "variable_name": "barely_wounded",
      "status_type": "none"
    },
    {
      "item_id": "C97076EF-FED9-19B4-D109-C22F9BC740E8",
      "item_name": "Wounded",
      "variable_name": "wounded",
      "status_type": "none"
    },
    {
      "item_id": "44B8792E-632E-2651-C666-67DFD181E92A",
      "item_name": "Bloodied",
      "variable_name": "bloodied",
      "status_type": "none"
    },
    {
      "item_id": "298BE1DD-2917-476E-D79C-92CF8C598926",
      "item_name": "Well Bloodied",
      "variable_name": "well_bloodied",
      "status_type": "none"
    },
    {
      "item_id": "D5DE14C4-3194-87BC-D767-6D45BDD90552",
      "item_name": "On Deaths Door",
      "variable_name": "on_deaths_door",
      "status_type": "none"
    },
    {
      "item_id": "8AE129AF-52D8-CCE8-706A-85767DB52740",
      "item_name": "Dying",
      "variable_name": "dying",
      "status_type": "bane"
    },
    {
      "item_id": "9FEE2E8A-9CF7-D74D-5D16-B86C2603A1FA",
      "item_name": "Dead",
      "variable_name": "dead",
      "status_type": "bane"
    },
    {
      "item_id": "F07C595F-D2DC-4CE9-904E-A4D73ABF9DEA",
      "item_name": "Stabilized",
      "variable_name": "stabilized",
      "status_type": "boon"
    },
    {
      "item_id": "99C862B9-D6AE-4E18-7803-A6F9B42A88E1",
      "item_name": "Crippled",
      "variable_name": "crippled",
      "status_type": "bane"
    },
    {
      "item_id": "78C6CC42-BCCE-4F22-9FC5-41F8D7E70944",
      "item_name": "Dying State",
      "variable_name": "dying_state",
      "status_type": "bane"
    },
    {
      "item_id": "EE063289-1AF3-41CF-B73C-64A0556E6D07",
      "item_name": "Dying State 1",
      "variable_name": "dying_state_1",
      "status_type": "bane"
    },
    {
      "item_id": "2EAAA2E8-1B9C-196D-3E58-C29C09FF8492",
      "item_name": "Dying State 2",
      "variable_name": "dying_state_2",
      "status_type": "bane"
    },
    {
      "item_id": "A9678CB1-11D3-55A3-E3C9-F342B2E40980",
      "item_name": "Dying State 3",
      "variable_name": "dying_state_3",
      "status_type": "bane"
    },
    {
      "item_id": "611DFED0-9AD1-5500-AF5B-DE7CBD9DDF64",
      "item_name": "Recovery State",
      "variable_name": "recovery_state",
      "status_type": "boon"
    },
    {
      "item_id": "553734EC-33D3-4527-AB2E-EF48ACED8DF0",
      "item_name": "Recovery State 1",
      "variable_name": "recovery_state_1",
      "status_type": "boon"
    },
    {
      "item_id": "9AA7588A-4575-9550-343D-6ADB0C74C17F",
      "item_name": "Recovery State 2",
      "variable_name": "recovery_state_2",
      "status_type": "boon"
    },
    {
      "item_id": "660E3133-44D8-E79F-C0ED-A26CE31D6E32",
      "item_name": "Recovery State 3",
      "variable_name": "recovery_state_3",
      "status_type": "boon"
    },
    {
      "item_id": "62E83DEB-4569-AE3A-F671-FF514C508FD2",
      "item_name": "Rotting",
      "variable_name": "rotting",
      "status_type": "bane"
    },
    {
      "item_id": "F7A1C3B2-5D64-4E18-9A70-2C8B41D5E093",
      "item_name": "Spoiling",
      "variable_name": "spoiling",
      "status_type": "bane"
    },
    {
      "item_id": "10C28483-A0E9-467F-993B-CBC440546A52",
      "item_name": "Received Prayer of Healing",
      "variable_name": "received_prayer_of_healing",
      "status_type": "none"
    }
  ],
  "PlayableClass": [
    {
      "item_id": "4B808990-16EB-52F5-0E88-EF0809F4C299",
      "item_name": "Barbarian",
      "item_type": "class",
      "variable_name": "barbarian",
      "icon_variable_name": "_barbarian",
      "primary_essence": "22918408-67CC-4093-80E8-BF6FA8915C21",
      "caster_type": "2FB5E45D-ADB1-15FC-6D0E-9814DFF5B49B"
    },
    {
      "item_id": "D656F798-435B-26F9-0332-0E489BBDEC7F",
      "item_name": "Bard",
      "item_type": "class",
      "variable_name": "bard",
      "icon_variable_name": "_bard",
      "primary_essence": "72F93730-134F-4CA2-8FC4-F2915F20CAC6",
      "caster_type": "A18765B6-F35A-47E2-F112-DF1582C37B37"
    },
    {
      "item_id": "6E4C0D81-46B8-BFF4-2D31-827EC8ACF3A7",
      "item_name": "Champion",
      "item_type": "class",
      "variable_name": "champion",
      "icon_variable_name": "_champion",
      "primary_essence": "22918408-67CC-4093-80E8-BF6FA8915C21",
      "caster_type": "2FB5E45D-ADB1-15FC-6D0E-9814DFF5B49B"
    },
    {
      "item_id": "2BCE19F7-76A3-EE20-3EA3-C2B8ADA88878",
      "item_name": "Deathbringer",
      "item_type": "class",
      "variable_name": "deathbringer",
      "icon_variable_name": "_deathbringer",
      "primary_essence": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8",
      "caster_type": "E8FB3E1F-2B16-4889-831C-99FC9E34853E"
    },
    {
      "item_id": "63056B34-DBA2-E711-1456-ED5E032A058C",
      "item_name": "Druid",
      "item_type": "class",
      "variable_name": "druid",
      "icon_variable_name": "_druid",
      "primary_essence": "72F93730-134F-4CA2-8FC4-F2915F20CAC6",
      "caster_type": "A18765B6-F35A-47E2-F112-DF1582C37B37"
    },
    {
      "item_id": "B9E74EDE-8D63-B137-F094-46054EF61512",
      "item_name": "Hunter",
      "item_type": "class",
      "variable_name": "hunter",
      "icon_variable_name": "_hunter",
      "primary_essence": "22918408-67CC-4093-80E8-BF6FA8915C21",
      "caster_type": "2FB5E45D-ADB1-15FC-6D0E-9814DFF5B49B"
    },
    {
      "item_id": "44223199-712F-A11F-BADD-EC10813AFBF7",
      "item_name": "Machinist",
      "item_type": "class",
      "variable_name": "machinist",
      "icon_variable_name": "_machinist",
      "primary_essence": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8",
      "caster_type": "2FB5E45D-ADB1-15FC-6D0E-9814DFF5B49B"
    },
    {
      "item_id": "74D15961-05FC-1D0C-DDF6-F518F026F22B",
      "item_name": "Monk",
      "item_type": "class",
      "variable_name": "monk",
      "icon_variable_name": "_monk",
      "primary_essence": "22918408-67CC-4093-80E8-BF6FA8915C21",
      "caster_type": "2FB5E45D-ADB1-15FC-6D0E-9814DFF5B49B"
    },
    {
      "item_id": "D28986FA-DCD0-F760-9F58-9E0AEF386F38",
      "item_name": "Paladin",
      "item_type": "class",
      "variable_name": "paladin",
      "icon_variable_name": "_paladin",
      "primary_essence": "72F93730-134F-4CA2-8FC4-F2915F20CAC6",
      "caster_type": "E8FB3E1F-2B16-4889-831C-99FC9E34853E"
    },
    {
      "item_id": "F573438B-0CA0-C945-B90F-5EFB6E1E1C99",
      "item_name": "Priest",
      "item_type": "class",
      "variable_name": "priest",
      "icon_variable_name": "_priest",
      "primary_essence": "72F93730-134F-4CA2-8FC4-F2915F20CAC6",
      "caster_type": "A18765B6-F35A-47E2-F112-DF1582C37B37"
    },
    {
      "item_id": "F2D31321-42E4-926B-892A-DF0A41176D14",
      "item_name": "Psion",
      "item_type": "class",
      "variable_name": "psion",
      "icon_variable_name": "_psion",
      "primary_essence": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8",
      "caster_type": "2FB5E45D-ADB1-15FC-6D0E-9814DFF5B49B"
    },
    {
      "item_id": "90474F60-446A-A55D-9B1F-9F974AD13D87",
      "item_name": "Shaman",
      "item_type": "class",
      "variable_name": "shaman",
      "icon_variable_name": "_shaman",
      "primary_essence": "72F93730-134F-4CA2-8FC4-F2915F20CAC6",
      "caster_type": "E8FB3E1F-2B16-4889-831C-99FC9E34853E"
    },
    {
      "item_id": "92303965-8EFD-8D5E-C18F-B4FF3A38CA72",
      "item_name": "Sorcerer",
      "item_type": "class",
      "variable_name": "sorcerer",
      "icon_variable_name": "_sorcerer",
      "primary_essence": "22918408-67CC-4093-80E8-BF6FA8915C21",
      "caster_type": "A18765B6-F35A-47E2-F112-DF1582C37B37"
    },
    {
      "item_id": "BD274DB4-75BE-BF81-FB33-A225748563BC",
      "item_name": "Spellblade",
      "item_type": "class",
      "variable_name": "spellblade",
      "icon_variable_name": "_spellblade",
      "primary_essence": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8",
      "caster_type": "E8FB3E1F-2B16-4889-831C-99FC9E34853E"
    },
    {
      "item_id": "35EDCE49-85F9-A36E-4407-547E0153DA05",
      "item_name": "Summoner",
      "item_type": "class",
      "variable_name": "summoner",
      "icon_variable_name": "_summoner",
      "primary_essence": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8",
      "caster_type": "2FB5E45D-ADB1-15FC-6D0E-9814DFF5B49B",
      "private": true
    },
    {
      "item_id": "D3F66A5C-A446-2217-697F-C174E2E5801E",
      "item_name": "Thief",
      "item_type": "class",
      "variable_name": "thief",
      "icon_variable_name": "_thief",
      "primary_essence": "22918408-67CC-4093-80E8-BF6FA8915C21",
      "caster_type": "2FB5E45D-ADB1-15FC-6D0E-9814DFF5B49B"
    },
    {
      "item_id": "4DDA161E-31D6-9894-58C7-CD34B21734BD",
      "item_name": "Warlock",
      "item_type": "class",
      "variable_name": "warlock",
      "icon_variable_name": "_warlock",
      "primary_essence": "72F93730-134F-4CA2-8FC4-F2915F20CAC6",
      "caster_type": "A18765B6-F35A-47E2-F112-DF1582C37B37"
    },
    {
      "item_id": "2BCF5CBC-1E87-E654-8310-E56EC051E559",
      "item_name": "Wizard",
      "item_type": "class",
      "variable_name": "wizard",
      "icon_variable_name": "_wizard",
      "primary_essence": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8",
      "caster_type": "A18765B6-F35A-47E2-F112-DF1582C37B37"
    }
  ],
  "CasterType": [
    {
      "item_id": "A18765B6-F35A-47E2-F112-DF1582C37B37",
      "item_name": "Full Caster",
      "item_type": "caster_type",
      "variable_name": "full_caster"
    },
    {
      "item_id": "E8FB3E1F-2B16-4889-831C-99FC9E34853E",
      "item_name": "Half Caster",
      "item_type": "caster_type",
      "variable_name": "half_caster"
    },
    {
      "item_id": "2FB5E45D-ADB1-15FC-6D0E-9814DFF5B49B",
      "item_name": "No Bending Powers",
      "item_type": "caster_type",
      "variable_name": "no_bending_powers"
    }
  ],
  "AbilityType": [
    "passive_ability",
    "full_ability",
    "ability",
    "quick_ability",
    "lair_ability",
    "trap_ability",
    "attack_ability",
    "free_ability",
    "reaction_ability",
    "opportunity_attack_ability",
    "curse",
    "menta",
    "sanguine",
    "ability_choice"
  ],
  "NaturalWeaponForm": [
    {
      "item_id": "2D894B13-AC1A-4BCD-8914-92EB4BDACC18",
      "item_name": "Natural Weapon Form \u2014 Bite",
      "item_type": "natural_weapon_form",
      "variable_name": "bite",
      "icon_variable_name": "natural_weapon",
      "description": "A jaw closing on the target. The head-slot family every bite rider (poison, disease, drain, elemental) is meant to ride."
    },
    {
      "item_id": "4C4FE4AE-E485-495B-8ED2-F22A35DA30E8",
      "item_name": "Natural Weapon Form \u2014 Beak",
      "item_type": "natural_weapon_form",
      "variable_name": "beak",
      "icon_variable_name": "natural_weapon",
      "description": "A hooked or shearing beak. Bird, roc and owlbear heads."
    },
    {
      "item_id": "A4A9688B-1C46-4A04-BDFE-552CF774547E",
      "item_name": "Natural Weapon Form \u2014 Gore",
      "item_type": "natural_weapon_form",
      "variable_name": "gore",
      "icon_variable_name": "natural_weapon",
      "description": "A driving thrust of the points on the head, delivered on the charge."
    },
    {
      "item_id": "5E805770-2DD5-4D6B-BC6D-8463D291C177",
      "item_name": "Natural Weapon Form \u2014 Horn",
      "item_type": "natural_weapon_form",
      "variable_name": "horn",
      "icon_variable_name": "natural_weapon",
      "description": "A horn or antler swept into the target. Distinct from gore: the sweep, not the charge."
    },
    {
      "item_id": "25C71284-9FE1-4FB5-982A-941913327B4A",
      "item_name": "Natural Weapon Form \u2014 Tusk",
      "item_type": "natural_weapon_form",
      "variable_name": "tusk",
      "icon_variable_name": "natural_weapon",
      "description": "An upward rip with the tusks of a boar or a mammoth."
    },
    {
      "item_id": "1D1BFF8B-39AC-4C8A-BD50-136A141E6A44",
      "item_name": "Natural Weapon Form \u2014 Ram",
      "item_type": "natural_weapon_form",
      "variable_name": "ram",
      "icon_variable_name": "natural_weapon",
      "description": "A headbutt \u2014 the skull itself as the weapon, no points involved."
    },
    {
      "item_id": "068FC154-D699-45DE-B085-F02B23F94DB9",
      "item_name": "Natural Weapon Form \u2014 Tongue",
      "item_type": "natural_weapon_form",
      "variable_name": "tongue",
      "icon_variable_name": "natural_weapon",
      "description": "A tongue lashed or shot out at range, frog- and roper-style."
    },
    {
      "item_id": "E03A9BC3-2D6E-4C5F-8FFB-D7BA35D99301",
      "item_name": "Natural Weapon Form \u2014 Pincer",
      "item_type": "natural_weapon_form",
      "variable_name": "pincer",
      "icon_variable_name": "natural_weapon",
      "description": "A chitinous claw that shears rather than rakes."
    },
    {
      "item_id": "7EBB7791-77C4-4C77-851D-9CCFAAAB3961",
      "item_name": "Natural Weapon Form \u2014 Lash",
      "item_type": "natural_weapon_form",
      "variable_name": "lash",
      "icon_variable_name": "natural_weapon",
      "description": "A whipping strand of flesh, hook or chain grown from the body."
    },
    {
      "item_id": "F7944C69-7A83-4BF1-9B39-C4EE05951309",
      "item_name": "Natural Weapon Form \u2014 Claw",
      "item_type": "natural_weapon_form",
      "variable_name": "claw",
      "icon_variable_name": "natural_weapon",
      "description": "A raking swipe of clawed limbs. The largest limb family in the catalog."
    },
    {
      "item_id": "F326ECEC-8545-48E6-80DC-B3901DD4CE37",
      "item_name": "Natural Weapon Form \u2014 Talon",
      "item_type": "natural_weapon_form",
      "variable_name": "talon",
      "icon_variable_name": "natural_weapon",
      "description": "The grasping talons of a bird of prey \u2014 a claw that seizes rather than rakes."
    },
    {
      "item_id": "B997BBBB-DC3F-4F8C-AB8E-A63C80AF133B",
      "item_name": "Natural Weapon Form \u2014 Rake",
      "item_type": "natural_weapon_form",
      "variable_name": "rake",
      "icon_variable_name": "natural_weapon",
      "description": "A raking kick with the hind legs, delivered from a grapple or pounce."
    },
    {
      "item_id": "E749A3D6-F04A-4890-85B2-ACD31A722718",
      "item_name": "Natural Weapon Form \u2014 Pseudopod",
      "item_type": "natural_weapon_form",
      "variable_name": "pseudopod",
      "icon_variable_name": "natural_weapon",
      "description": "A limb extruded from an amorphous body \u2014 oozes, elementals and shaped matter."
    },
    {
      "item_id": "DDB21DE1-F41C-4456-B99C-D1B9D8742B84",
      "item_name": "Natural Weapon Form \u2014 Slam",
      "item_type": "natural_weapon_form",
      "variable_name": "slam",
      "icon_variable_name": "natural_weapon",
      "description": "A whole-body blow: fist, trunk, wing or bulk driven into the target."
    },
    {
      "item_id": "16DE3886-A2B7-4957-A751-AE08F048BADD",
      "item_name": "Natural Weapon Form \u2014 Tentacle",
      "item_type": "natural_weapon_form",
      "variable_name": "tentacle",
      "icon_variable_name": "natural_weapon",
      "description": "A long boneless arm that reaches, wraps and drags."
    },
    {
      "item_id": "B8324075-E65F-455C-BD40-B09C95B02812",
      "item_name": "Natural Weapon Form \u2014 Constrict",
      "item_type": "natural_weapon_form",
      "variable_name": "constrict",
      "icon_variable_name": "natural_weapon",
      "description": "A coiling body that crushes what it has already wrapped."
    },
    {
      "item_id": "FAEFBA34-2176-46E5-911D-51580EF6DA74",
      "item_name": "Natural Weapon Form \u2014 Stinger",
      "item_type": "natural_weapon_form",
      "variable_name": "stinger",
      "icon_variable_name": "natural_weapon",
      "description": "A barbed tail tip that drives venom in on the hit."
    },
    {
      "item_id": "FABD5931-2BE5-4A39-BD45-62529717A62F",
      "item_name": "Natural Weapon Form \u2014 Tail",
      "item_type": "natural_weapon_form",
      "variable_name": "tail",
      "icon_variable_name": "tail",
      "description": "A tail swung as a club or sweep, without a sting."
    },
    {
      "item_id": "4BC81F0D-4C96-44B0-AD91-422E0A6E5259",
      "item_name": "Natural Weapon Form \u2014 Hoof",
      "item_type": "natural_weapon_form",
      "variable_name": "hoof",
      "icon_variable_name": "natural_weapon",
      "description": "A shod or cloven hoof kicked into the target."
    },
    {
      "item_id": "06BBC9AA-3BED-43A4-9EC3-96072F827C04",
      "item_name": "Natural Weapon Form \u2014 Stomp",
      "item_type": "natural_weapon_form",
      "variable_name": "stomp",
      "icon_variable_name": "natural_weapon",
      "description": "A downward crush with the full weight of the body behind it."
    },
    {
      "item_id": "287DFA0C-FD83-4305-A41E-D26CE7CE1CCC",
      "item_name": "Natural Weapon Form \u2014 Spine",
      "item_type": "natural_weapon_form",
      "variable_name": "spine",
      "icon_variable_name": "natural_weapon",
      "description": "Quills, thorns or needles loosed or driven from the body."
    },
    {
      "item_id": "2C02D1AA-5FBD-470C-8154-B5304BE28D13",
      "item_name": "Natural Weapon Form \u2014 Hurl",
      "item_type": "natural_weapon_form",
      "variable_name": "hurl",
      "icon_variable_name": "natural_weapon",
      "description": "Matter torn loose and thrown \u2014 the natural-weapon equivalent of a ranged attack."
    },
    {
      "item_id": "83CA2730-7598-44D6-BDA2-CDE4B040E73B",
      "item_name": "Natural Weapon Form \u2014 Other",
      "item_type": "natural_weapon_form",
      "variable_name": "other",
      "icon_variable_name": "natural_weapon",
      "description": "A natural weapon whose shape fits none of the named forms. Deliberately not a bucket to grow \u2014 add a form instead."
    }
  ],
  "NaturalWeaponSkillTierGrant": [
    {
      "item_id": "02FFED44-7A58-4EF2-EF07-2FFD980A3049",
      "item_name": "Natural Weapon (min skill tier 14)",
      "item_type": "natural_weapon",
      "variable_name": "min_skill_tier_14"
    },
    {
      "item_id": "34CEB0D1-1DE2-03F7-BB8A-834BF8F3565A",
      "item_name": "Natural Weapon (min skill tier 9)",
      "item_type": "natural_weapon",
      "variable_name": "min_skill_tier_9"
    },
    {
      "item_id": "D266179F-EAD6-AAF2-EC00-EAF45679AD0B",
      "item_name": "Natural Weapon (min skill tier 7)",
      "item_type": "natural_weapon",
      "variable_name": "min_skill_tier_7"
    },
    {
      "item_id": "39EBAEF7-1ED7-5AAF-E88B-8C50B96B5ED8",
      "item_name": "Natural Weapon (min skill tier 5)",
      "item_type": "natural_weapon",
      "variable_name": "min_skill_tier_5"
    },
    {
      "item_id": "7F6E7D26-77CE-801A-51F7-1CEE17153C70",
      "item_name": "Natural Weapon (min skill tier 3)",
      "item_type": "natural_weapon",
      "variable_name": "min_skill_tier_3"
    },
    {
      "item_id": "7E0421DF-EA86-90AA-E95D-30145B3F43BD",
      "item_name": "Natural Weapon (min skill tier 1)",
      "item_type": "natural_weapon",
      "variable_name": "min_skill_tier_1"
    }
  ],
  "WeaponClassificationType": [
    {
      "item_id": "B66B3311-4A62-5531-D446-CE4A565FD181",
      "item_name": "Colossal Ranged Weapons",
      "variable_name": "colossal_ranged_weapons",
      "required_passive_for_equip": "5E7E3B4E-3350-448C-E959-0C7A59D4867E",
      "required_feat_for_equip": "9A5C417C-D482-199D-4FDB-2296A7DF6F7F"
    },
    {
      "item_id": "B12431F6-BB7A-8079-002F-111914B9E65A",
      "item_name": "Colossal Melee Weapons",
      "variable_name": "colossal_melee_weapons",
      "required_passive_for_equip": "867FE4B0-29AC-B2D9-B91B-CC468789C17D",
      "required_feat_for_equip": "F3298F3D-8106-B017-D009-B66B4F7D7785"
    },
    {
      "item_id": "AB7DEAAE-62BF-4996-A510-5F2B192F8F14",
      "item_name": "Natural Weapon",
      "variable_name": "natural_weapon"
    },
    {
      "item_id": "F187EE82-1D32-4C53-9F69-E59DDF33D7C7",
      "item_name": "Fist Weapons",
      "variable_name": "fist_weapons"
    },
    {
      "item_id": "6284CE8F-C929-7161-EC43-923DE40F4968",
      "item_name": "Clubs",
      "variable_name": "clubs"
    },
    {
      "item_id": "48C941BC-2E9A-CAD8-1DA7-D90AE8DB1768",
      "item_name": "Sickles",
      "variable_name": "sickles"
    },
    {
      "item_id": "742A06CA-5870-FA3B-603A-AEE94F5102F5",
      "item_name": "Whips",
      "variable_name": "whips"
    },
    {
      "item_id": "50740150-28E8-FB76-88BD-216B02569D3F",
      "item_name": "Daggers",
      "variable_name": "daggers"
    },
    {
      "item_id": "67EFA62C-3A5C-9FEE-D54D-EF7615C063F4",
      "item_name": "Hammers, Light",
      "variable_name": "hammers_light"
    },
    {
      "item_id": "57B8F98F-460E-7D39-C495-D2E26439391C",
      "item_name": "Shortswords",
      "variable_name": "shortswords"
    },
    {
      "item_id": "AFFA2CC1-0468-ABBC-2FA3-40597B8B374D",
      "item_name": "Scimitars",
      "variable_name": "scimitars"
    },
    {
      "item_id": "5E58B1EB-B2AD-5F54-B4DD-D8DDA5E8BCE3",
      "item_name": "Maces",
      "variable_name": "maces"
    },
    {
      "item_id": "859394A9-EE4A-BD9A-C5A9-7FCD150E7344",
      "item_name": "Handaxes",
      "variable_name": "handaxes"
    },
    {
      "item_id": "2FB5E21A-7A0A-E4B8-604D-3A0A60A34172",
      "item_name": "Javelins",
      "variable_name": "javelins"
    },
    {
      "item_id": "12D25118-B86A-80A5-01BC-C9427BD83D17",
      "item_name": "Quarterstaffs",
      "variable_name": "quarterstaffs"
    },
    {
      "item_id": "7D08EF0E-0D7D-8CB0-70FA-0C741AF438E5",
      "item_name": "Spears",
      "variable_name": "spears"
    },
    {
      "item_id": "CF8B21A5-32CE-7E43-22E3-ABC56C457628",
      "item_name": "Tridents",
      "variable_name": "tridents"
    },
    {
      "item_id": "2F238366-80B8-2BCF-EC81-387CE1A5D4DF",
      "item_name": "Rapiers",
      "variable_name": "rapiers"
    },
    {
      "item_id": "622AEA0A-D1A6-FB1C-83B4-FC67807D9197",
      "item_name": "War Picks",
      "variable_name": "war_picks"
    },
    {
      "item_id": "AD9D5036-D2CF-1C6A-9785-CCB5D35B96B5",
      "item_name": "Morningstars",
      "variable_name": "morningstars"
    },
    {
      "item_id": "D5906717-7237-CA1D-B089-18CF323A04DB",
      "item_name": "Flails",
      "variable_name": "flails"
    },
    {
      "item_id": "B5ECBC44-BAB8-E6B2-0D1C-CC2A5082BDD2",
      "item_name": "Greatclubs",
      "variable_name": "greatclubs"
    },
    {
      "item_id": "DE15C4F8-2710-8187-3788-2DA46D8724B8",
      "item_name": "Scythes",
      "variable_name": "scythes"
    },
    {
      "item_id": "5C17EFAF-2F94-E2E4-02A2-791F241BD52B",
      "item_name": "Bladed Fans",
      "variable_name": "bladed_fans"
    },
    {
      "item_id": "E48B1524-C478-E245-AF07-2A1A145EE4D5",
      "item_name": "Longswords",
      "variable_name": "longswords"
    },
    {
      "item_id": "1B08D135-FE7B-4180-6F38-A1FEEF733355",
      "item_name": "Battleaxes",
      "variable_name": "battleaxes"
    },
    {
      "item_id": "3AC99772-BF88-6507-8360-EE3EAFC7540F",
      "item_name": "Warhammers",
      "variable_name": "warhammers"
    },
    {
      "item_id": "864FC3D6-0B39-7F59-0274-09B98850A41F",
      "item_name": "Glaives",
      "variable_name": "glaives"
    },
    {
      "item_id": "5B8E8F69-AB95-617A-5E82-8F9C4D2C2485",
      "item_name": "Halberds",
      "variable_name": "halberds"
    },
    {
      "item_id": "E4FB85CE-C211-BE13-B674-A2A591384C11",
      "item_name": "Pikes",
      "variable_name": "pikes"
    },
    {
      "item_id": "7FA88F1A-084A-4A05-1B5D-27B56EDDED6F",
      "item_name": "Greataxes",
      "variable_name": "greataxes"
    },
    {
      "item_id": "545EB766-1371-C2E2-2664-0C191EAC9C3F",
      "item_name": "Lances",
      "variable_name": "lances"
    },
    {
      "item_id": "26BF8308-1F2B-656E-FF25-9EB2D1E0EEE0",
      "item_name": "Double-Bladed Scimitars",
      "variable_name": "double_bladed_scimitars"
    },
    {
      "item_id": "FB124CCD-B381-452B-CAA1-B598E90A8534",
      "item_name": "Greatswords",
      "variable_name": "greatswords"
    },
    {
      "item_id": "40DDC931-6479-B773-293E-CE570E99B975",
      "item_name": "Bladed Umbrellas",
      "variable_name": "bladed_umbrellas"
    },
    {
      "item_id": "44A52695-9CD1-804C-9ABA-178B70704D59",
      "item_name": "Mauls",
      "variable_name": "mauls"
    },
    {
      "item_id": "488EE738-F198-9F9E-4F9F-FE26B06BA64F",
      "item_name": "Nets",
      "variable_name": "nets"
    },
    {
      "item_id": "D80255AC-6D02-0158-0796-76D110DE7778",
      "item_name": "Blowguns",
      "variable_name": "blowguns"
    },
    {
      "item_id": "9F33304D-BEB8-86B5-3928-A4D98293DF97",
      "item_name": "Darts",
      "variable_name": "darts"
    },
    {
      "item_id": "D7BB53E2-0544-9AC9-7DD3-4FA47A12C80C",
      "item_name": "Slings",
      "variable_name": "slings"
    },
    {
      "item_id": "81AF4123-10E6-8656-F9CA-DCE1AC3DC7E3",
      "item_name": "Rope Darts",
      "variable_name": "rope_darts"
    },
    {
      "item_id": "6C92300B-B840-9E37-BF4D-46A166407E7B",
      "item_name": "Shortbows",
      "variable_name": "shortbows"
    },
    {
      "item_id": "E6CCEF87-419A-57CF-DC12-73324DB86CD1",
      "item_name": "Crossbows, Hand",
      "variable_name": "crossbows_hand"
    },
    {
      "item_id": "207C31FE-ABEE-96F1-2EA6-B98635F7D730",
      "item_name": "Longbows",
      "variable_name": "longbows"
    },
    {
      "item_id": "8C25C0CD-AF02-6648-A158-87F4DEBB8651",
      "item_name": "Crossbows, Light",
      "variable_name": "crossbows_light"
    },
    {
      "item_id": "7257525A-37A8-9DCE-1656-C7449FF2C305",
      "item_name": "Crossbows, Heavy",
      "variable_name": "crossbows_heavy"
    },
    {
      "item_id": "FCED5C37-344C-1B6A-7598-E682452C1AA9",
      "item_name": "Palm Pistols",
      "variable_name": "palm_pistols"
    },
    {
      "item_id": "60509B0C-A1BB-B005-C834-98E5ACE40BAB",
      "item_name": "Pistols",
      "variable_name": "pistols"
    },
    {
      "item_id": "BCC74411-8516-A30B-B79A-1DBED89C61A6",
      "item_name": "Pepperboxes",
      "variable_name": "pepperboxes"
    },
    {
      "item_id": "3BBEE883-286A-4A08-3CCB-52F283348345",
      "item_name": "Muskets",
      "variable_name": "muskets"
    },
    {
      "item_id": "7F3F7FC7-0CCF-E01A-22BA-E0AA0A97686D",
      "item_name": "Blunderbusses",
      "variable_name": "blunderbusses"
    },
    {
      "item_id": "E54B8A46-A63F-AB3A-BAA9-C27826B0AF5F",
      "item_name": "Longshot Rifles",
      "variable_name": "longshot_rifles"
    },
    {
      "item_id": "5310DE5D-1453-5468-EBBA-B1132AB19394",
      "item_name": "Hand Mortars",
      "variable_name": "hand_mortars"
    }
  ],
  "CampaignHouseRuleType": [
    {
      "item_id": "51219FD2-350B-3C07-16B1-C0382B0C4EB3",
      "item_name": "Magic: Overcasting",
      "item_type": "campaign_house_rule_type",
      "variable_name": "magic_overcasting_all_casters"
    },
    {
      "item_id": "0B99F086-B50F-236E-CBBD-AB4E617E75E8",
      "item_name": "Combat: No Called Shots",
      "item_type": "campaign_house_rule_type",
      "variable_name": "combat_no_called_shots"
    },
    {
      "item_id": "6AE51489-5732-6F8B-3ACC-45B0B9118F3C",
      "item_name": "Damage: Exploding Dice",
      "item_type": "campaign_house_rule_type",
      "variable_name": "exploding_damage_dice"
    },
    {
      "item_id": "2087C1FB-57E3-2E51-AC0E-6FF8C15629AA",
      "item_name": "Critical Hits: Maximum Dice (default)",
      "item_type": "campaign_house_rule_type",
      "variable_name": "critical_hits_maximum_dice"
    },
    {
      "item_id": "6CFB808D-D8BE-7A0C-E2E2-03F68E26DDA8",
      "item_name": "Critical Hits: Rolled Dice",
      "item_type": "campaign_house_rule_type",
      "variable_name": "critical_hits_rolled_dice"
    },
    {
      "item_id": "726E0917-9257-23FD-A18C-C07B4C00B8A1",
      "item_name": "Critical Hits: Doubled Damage",
      "item_type": "campaign_house_rule_type",
      "variable_name": "critical_hits_doubled_damage"
    },
    {
      "item_id": "6C85D904-D3AE-5680-666F-5FC49A4FFF4D",
      "item_name": "Critical Hits: Improved Damage - Remarkable (20 x 2)",
      "item_type": "campaign_house_rule_type",
      "variable_name": "critical_hits_improved_damage_remarkable"
    },
    {
      "item_id": "71221E94-E2E8-EF30-EE0E-8E4C53860250",
      "item_name": "Critical Hits: Improved Damage - World-shaking (20 x 3)",
      "item_type": "campaign_house_rule_type",
      "variable_name": "critical_hits_improved_damage_world_shaking"
    },
    {
      "item_id": "FFFE4F7F-0018-4961-5BB9-2B69268CD48E",
      "item_name": "Critical Hits: Maimed",
      "item_type": "campaign_house_rule_type",
      "variable_name": "maimed_on_crit_fortitude_save"
    },
    {
      "item_id": "0A0B2172-AF81-5D5B-188C-294D5DDB7B74",
      "item_name": "Dying Rolls: Maimed",
      "item_type": "campaign_house_rule_type",
      "variable_name": "maimed_on_dying_stratum_fail_by_5"
    },
    {
      "item_id": "D5E5FD24-26D9-76BB-1223-003C98D07F69",
      "item_name": "Massive Damage: Maimed",
      "item_type": "campaign_house_rule_type",
      "variable_name": "maimed_on_massive_damage_fortitude_save"
    },
    {
      "item_id": "F1F5285D-E498-4B20-956C-C4CC51015DFC",
      "item_name": "Inventory: No Encumbrance",
      "item_type": "campaign_house_rule_type",
      "variable_name": "no_encumbrance"
    },
    {
      "item_id": "03788F23-69EB-9DA7-1D4C-C07B93A33070",
      "item_name": "Unhide Meta Rolls",
      "item_type": "campaign_house_rule_type",
      "variable_name": "unhide_meta_rolls"
    }
  ],
  "SizeType": [
    {
      "item_id": "13456FEC-A2EE-DB46-5829-0EB2F627E1B7",
      "item_name": "Tiny",
      "item_type": "size_type",
      "variable_name": "tiny",
      "base_size": 2.5,
      "weight_multiplier": 3,
      "hunger_meter_max": 25,
      "thirst_meter_max": 25,
      "thumbnail_width": 40,
      "thumbnail_height": 40,
      "reach": "+3",
      "vitality_scale": 0.25,
      "required_weapon_size_fit_passive": "C80A28EC-E4DF-664C-FA7C-870A8A53C032",
      "required_armor_size_fit_passive": "64C7938A-010C-1527-6890-A4BC39362807"
    },
    {
      "item_id": "AAC1F466-7A8B-C593-1ADC-FC402B8909D7",
      "item_name": "Small",
      "item_type": "size_type",
      "variable_name": "small",
      "base_size": 3.75,
      "weight_multiplier": 7,
      "hunger_meter_max": 50,
      "thirst_meter_max": 50,
      "thumbnail_width": 60,
      "thumbnail_height": 60,
      "reach": "+5",
      "vitality_scale": 0.6
    },
    {
      "item_id": "DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC",
      "item_name": "Medium - Size",
      "item_type": "size_type",
      "variable_name": "medium",
      "base_size": 5,
      "weight_multiplier": 10,
      "hunger_meter_max": 100,
      "thirst_meter_max": 100,
      "thumbnail_width": 80,
      "thumbnail_height": 80,
      "reach": "+5",
      "vitality_scale": 1
    },
    {
      "item_id": "52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD",
      "item_name": "Large",
      "item_type": "size_type",
      "variable_name": "large",
      "base_size": 10,
      "weight_multiplier": 20,
      "hunger_meter_max": 200,
      "thirst_meter_max": 200,
      "thumbnail_width": 160,
      "thumbnail_height": 160,
      "reach": "+5",
      "vitality_scale": 4,
      "required_weapon_size_fit_passive": "BD02A97E-8EB3-445A-8758-B01E089FFE03",
      "required_armor_size_fit_passive": "83D21DE1-B6D9-877E-9B6E-56734C400643"
    },
    {
      "item_id": "D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C",
      "item_name": "Huge",
      "item_type": "size_type",
      "variable_name": "huge",
      "base_size": 15,
      "weight_multiplier": 40,
      "hunger_meter_max": 400,
      "thirst_meter_max": 400,
      "thumbnail_width": 240,
      "thumbnail_height": 240,
      "reach": "+10",
      "vitality_scale": 15,
      "required_weapon_size_fit_passive": "F74CFA32-D114-191D-CC2F-C8DE12B8E871",
      "required_armor_size_fit_passive": "BE936924-6C8B-CBEC-3E77-6D47B1F98959"
    },
    {
      "item_id": "CEA2946E-D395-46EA-A6E7-74D21EA2376E",
      "item_name": "Gargantuan",
      "item_type": "size_type",
      "variable_name": "gargantuan",
      "base_size": 20,
      "weight_multiplier": 80,
      "hunger_meter_max": 800,
      "thirst_meter_max": 800,
      "thumbnail_width": 320,
      "thumbnail_height": 320,
      "reach": "+10",
      "vitality_scale": 50,
      "required_weapon_size_fit_passive": "4C7C35F9-F948-581F-0F2D-11BAFC476122",
      "required_armor_size_fit_passive": "65532C69-CC39-2614-CABC-C4D5EB9ACE48"
    },
    {
      "item_id": "C94CDD74-8ACD-26B0-5C53-4CA29CF21D68",
      "item_name": "Colossal",
      "item_type": "size_type",
      "variable_name": "colossal",
      "base_size": 25,
      "weight_multiplier": 160,
      "hunger_meter_max": 1600,
      "thirst_meter_max": 1600,
      "thumbnail_width": 400,
      "thumbnail_height": 400,
      "reach": "+15",
      "vitality_scale": 160,
      "required_weapon_size_fit_passive": "C05381EC-D66A-15AC-46F0-42F5EA8D9383",
      "required_armor_size_fit_passive": "7C0A9429-D170-041B-727B-5D3762D9CFC5"
    },
    {
      "item_id": "4C33FD22-5382-15DA-1C46-F57F14378AFD",
      "item_name": "Titanic",
      "item_type": "size_type",
      "variable_name": "titanic",
      "base_size": 30,
      "weight_multiplier": 320,
      "hunger_meter_max": 3200,
      "thirst_meter_max": 3200,
      "thumbnail_width": 480,
      "thumbnail_height": 480,
      "reach": "+20",
      "vitality_scale": 500,
      "required_weapon_size_fit_passive": "44D45637-FCFE-FC95-BE32-DD47FCAEC116",
      "required_armor_size_fit_passive": "A0DC40FE-BA7A-89FC-CA10-1C15BBAD6EDF"
    }
  ],
  "EquipmentSlot": [
    {
      "item_id": "F2D8C4B3-FA31-291C-995A-2046F84A289F",
      "item_name": "Air Around",
      "variable_name": "air_around",
      "slot_limit": 1
    },
    {
      "item_id": "0B279A55-5102-D704-8A57-0C1FF4989DFA",
      "item_name": "Armor",
      "variable_name": "armor",
      "slot_limit": 1
    },
    {
      "item_id": "F19F7A27-C0EE-DCFF-BD8F-2FA3CC03F7BB",
      "item_name": "Back",
      "variable_name": "back",
      "slot_limit": 1
    },
    {
      "item_id": "E6D02ACB-D3E9-DD8B-762A-31FE8C8D898D",
      "item_name": "Both Hands",
      "variable_name": "both_hands",
      "slot_limit": 1
    },
    {
      "item_id": "BD255B29-389B-53DC-6116-072B1A8DDD5F",
      "item_name": "Bracers",
      "variable_name": "bracers",
      "slot_limit": 1
    },
    {
      "item_id": "C48555B1-E374-9AAD-8CA0-C55D07AD6776",
      "item_name": "Breast",
      "variable_name": "breast",
      "slot_limit": 1
    },
    {
      "item_id": "6203F9AE-6699-AB57-B3C7-92864A79520C",
      "item_name": "Cloak",
      "variable_name": "cloak",
      "slot_limit": 1
    },
    {
      "item_id": "3CAA3182-3DA6-F348-CEE3-09803F221466",
      "item_name": "Clothing",
      "variable_name": "clothing",
      "slot_limit": 1
    },
    {
      "item_id": "94805078-0B0F-FD3F-77E4-AA6EE4D2E44D",
      "item_name": "Feet",
      "variable_name": "feet",
      "slot_limit": 1
    },
    {
      "item_id": "3805BDD7-3461-DDDB-F445-922A5A992987",
      "item_name": "Head",
      "variable_name": "head",
      "slot_limit": 1
    },
    {
      "item_id": "AF43D701-0755-C7E2-D26F-44E6F64AC3E2",
      "item_name": "Legs",
      "variable_name": "legs",
      "slot_limit": 1
    },
    {
      "item_id": "CEF334BF-DE96-1BEA-F72A-A4C98FBF36AD",
      "item_name": "Main Hand",
      "variable_name": "main_hand",
      "slot_limit": 1
    },
    {
      "item_id": "3CA73C13-5DC3-0DDF-CAD8-98D1CF573844",
      "item_name": "Natural Armor",
      "variable_name": "natural_armor",
      "slot_limit": 1
    },
    {
      "item_id": "5EDE9876-ED2B-3B93-C683-34428B5FDA5B",
      "item_name": "Neck",
      "variable_name": "neck",
      "slot_limit": 1
    },
    {
      "item_id": "4FF85144-67EC-9D87-AE28-15137A1A2481",
      "item_name": "Off Hand",
      "variable_name": "off_hand",
      "slot_limit": 1
    },
    {
      "item_id": "3AD8CEE8-D487-68B1-33F0-CFE04336F9B8",
      "item_name": "Ring",
      "variable_name": "ring",
      "slot_limit": 2
    },
    {
      "item_id": "16ABAE95-5D18-474D-ADFF-8C20FC2439F1",
      "item_name": "Tail",
      "variable_name": "tail",
      "slot_limit": 1
    },
    {
      "item_id": "B52059C5-526B-3F8C-E906-0D40FA23A593",
      "item_name": "Waist",
      "variable_name": "waist",
      "slot_limit": 3
    }
  ],
  "Essence": [
    {
      "item_id": "22918408-67CC-4093-80E8-BF6FA8915C21",
      "item_name": "Body",
      "item_type": "essence",
      "variable_name": "body"
    },
    {
      "item_id": "63ABC96E-3804-4E1F-B38D-AABA3237B2D8",
      "item_name": "Mind",
      "item_type": "essence",
      "variable_name": "mind"
    },
    {
      "item_id": "72F93730-134F-4CA2-8FC4-F2915F20CAC6",
      "item_name": "Soul",
      "item_type": "essence",
      "variable_name": "soul"
    },
    {
      "item_id": "86792A8B-2070-4144-9C81-0D85706131DF",
      "item_name": "Spirit",
      "item_type": "essence",
      "variable_name": "spirit"
    },
    {
      "item_id": "E769E451-65EE-3628-1A78-D12C9A3FF02B",
      "item_name": "Fortune",
      "item_type": "essence",
      "variable_name": "fortune"
    },
    {
      "item_id": "7B7E8F97-6843-57CF-422C-5930CFA98B06",
      "item_name": "Luck",
      "item_type": "essence",
      "variable_name": "luck"
    }
  ],
  "CraftingSkill": [
    {
      "item_id": "86BD9ED9-4768-239D-E755-BC198290FDBE",
      "item_name": "Alchemy",
      "item_type": "crafting_skill",
      "variable_name": "alchemy",
      "recipe_name": "alchemy_recipe",
      "recipe_names": [
        "alchemy_recipe",
        "brewing_recipe"
      ],
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "9CC50F9B-B8AD-B180-79BE-C309F1563800",
      "item_name": "Art",
      "item_type": "crafting_skill",
      "variable_name": "art",
      "recipe_name": "art_recipe",
      "recipe_names": [
        "art_recipe"
      ],
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "7229802A-2169-DDD4-6CCB-E755CCFAEB51",
      "item_name": "Cooking",
      "item_type": "crafting_skill",
      "variable_name": "cooking",
      "recipe_name": "cooking_recipe",
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "E77A8B34-F880-E0E2-E6EC-42F4241F4FCC",
      "item_name": "Enchanting",
      "item_type": "crafting_skill",
      "variable_name": "enchanting",
      "recipe_name": "enchanting_recipe",
      "recipe_names": [
        "enchanting_recipe",
        "runeforging_recipe"
      ],
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "B27AC929-722C-685E-E93E-CE38F49FF9BE",
      "item_name": "Glassblowing",
      "item_type": "crafting_skill",
      "variable_name": "glassblowing",
      "recipe_name": "glassblowing_recipe",
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "AFD61488-049C-C7FC-2B72-26CBE7EAEAFD",
      "item_name": "Jewelling",
      "item_type": "crafting_skill",
      "variable_name": "jewelling",
      "recipe_name": "jewelling_recipe",
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "F29D806E-160C-4EC2-923F-AAF1D5CDDB7E",
      "item_name": "Leatherworking",
      "item_type": "crafting_skill",
      "variable_name": "leatherworking",
      "recipe_name": "leatherworking_recipe",
      "recipe_names": [
        "leatherworking_recipe",
        "cobbling_recipe",
        "tanning_recipe"
      ],
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "D7F51670-F6D9-5DD6-11D9-0CDBF35096A0",
      "item_name": "Machining",
      "item_type": "crafting_skill",
      "variable_name": "machining",
      "recipe_name": "machining_recipe",
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "6C3E6964-F138-CA3F-DB99-4BFC7AF3E4FB",
      "item_name": "Masoning",
      "item_type": "crafting_skill",
      "variable_name": "masoning",
      "recipe_name": "masoning_recipe",
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "0A68ECAB-D224-CF73-DB51-761BCFD663FA",
      "item_name": "Smithing",
      "item_type": "crafting_skill",
      "variable_name": "smithing",
      "recipe_name": "smithing_recipe",
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "55565C71-B55B-3D10-9DFB-7C45D95BC724",
      "item_name": "Weaving",
      "item_type": "crafting_skill",
      "variable_name": "weaving",
      "recipe_name": "weaving_recipe",
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    },
    {
      "item_id": "E5347227-42FD-9173-6C81-ADAD3E0ED6ED",
      "item_name": "Woodworking",
      "item_type": "crafting_skill",
      "variable_name": "woodworking",
      "recipe_name": "woodworking_recipe",
      "recipe_names": [
        "woodworking_recipe"
      ],
      "essence_used": "72F93730-134F-4CA2-8FC4-F2915F20CAC6"
    }
  ]
}
